import React from "react";
import style from "./SwitchButton.module.css"; // Import the CSS file for styling

const SwitchButton = ({ activeButton, setActiveButton }) => {
  // State to track the currently active button

  // function handleSelection(e) {
  //   setActiveButton(e.target.value);
  // }

  return (
    <div className={style.selectContainer}>
      <button
        className={activeButton === "Container" ? `${style.active}` : ""}
        onClick={() => setActiveButton("Container")}
      >
        Detect
      </button>
      <button
        className={activeButton === "Image" ? `${style.active}` : ""}
        onClick={() => setActiveButton("Image")}
      >
        Collect
      </button>
    </div>
  );
};
export default SwitchButton;
